import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDashboardPath, UNIFIED_LOGIN_PATH } from "../../utils/authRedirect";

/**
 * Корень портала клуба (/, /staff, /manage) — без лендинга:
 * авторизован → кабинет по роли, иначе → единая страница входа.
 */
export default function PortalEntryRedirect() {
  const { isAuth, role } = useSelector((state) => state.auth);

  if (isAuth && role) {
    return <Navigate to={getDashboardPath(role)} replace />;
  }

  return <Navigate to={UNIFIED_LOGIN_PATH} replace />;
}
